import React, { useEffect, useState, useRef } from "react"
import { PageHeader } from "../../molecules/PageHeader"
import { connect } from "react-redux"
import moment from "moment"
import history from "../../history"
import { ArrowLeftOutlined } from "@ant-design/icons"
import {
  BACK_BUTTON,
  JOURNAL_LABEL,
  JOURNAL_WITH_LABEL,
  QUESTIONS,
  ANSWER_PLACEHOLDER,
  PARTNER_NOT_MATCHED,
  INVITE_LINK,
  DATE_PLACEHOLDER,
  SAVED_MESSAGE,
  MESSAGE_TIMEOUT,
  YEAR_MONTH_DATE_FORMAT,
  DATE_MONTH_YEAR_FORMAT,
} from "../../constants/messages"
import {
  FirebaseContext,
  FIREBASE_STATE_KEYS,
  FirebaseService,
} from "../../firebase"
import { getChatSpaceName, getPartnerNameorNickName } from "../../utils/helpers"
import "./JournalPage.scss"

import question1 from "../../assets/images/question1.gif"
import question2 from "../../assets/images/question2.gif"
import question3 from "../../assets/images/question3.gif"
import question4 from "../../assets/images/question4.gif"
import question5 from "../../assets/images/question5.gif"
import question6 from "../../assets/images/question6.gif"

import { TextTag as Text, TextArea, TextAreaWithIcon, Date } from "../../atoms"
import _ from "../../utils/lodashUtils"
import {
  saveAnswer,
  getAllAnswers,
  saveJournalDate,
} from "../../redux/actionCreators/sharedProfile"

const JournalPage = props => {
  const { dateState, partnerState, userState } = React.useContext(
    FirebaseContext
  )
  const firebaseDefaultPath = FirebaseService.getDefaultPath()
  const {
    partnerDetails,
    myPartner,
    saveAnswer,
    getAllAnswers,
    sharedProfile,
    saveJournalDate,
  } = props

  const chatSpaceName = getChatSpaceName(dateState, partnerDetails)
  const partnerName = getPartnerNameorNickName(
    partnerState,
    myPartner,
    partnerDetails
  )
  const [Question, setanswers] = useState({})
  const [PartnerQuestion, setPartnerAnswers] = useState({})
  const [savedMessage, setSavedMessage] = useState({})
  const [images, setAllImages] = useState([
    question1,
    question2,
    question3,
    question4,
    question5,
    question6,
  ])
  const inputRef = useRef()
  const [answerInputRef, setInputRef] = useState(inputRef)

  const getMomentDateFormat = date => {
    var d = moment(date)
    return date && d.isValid() ? d : ""
  }
  const getStringDateFormat = (date, dateString) => {
    return dateString
      ? moment(dateString, DATE_MONTH_YEAR_FORMAT).format(
          YEAR_MONTH_DATE_FORMAT
        )
      : ""
  }

  useEffect(() => {
    // get saved answers
    if (partnerDetails) {
      getAllAnswers()
    }
  }, [partnerDetails])

  useEffect(() => {
    const firebaseUserAnswer = _.get(
      userState,
      `${FIREBASE_STATE_KEYS.SHARED_PROFILE_ANSWERS}`,
      {}
    )
    const userAnswers =
      firebaseUserAnswer && !_.isEmpty(firebaseUserAnswer)
        ? firebaseUserAnswer
        : _.get(sharedProfile, "userAnswers")
    //to set each text area
    if (userAnswers) {
      Object.keys(userAnswers).forEach((key, index) => {
        setanswers(prevState => ({
          ...prevState,
          [key]: userAnswers[key],
        }))
      })
    }
  }, [userState])

  useEffect(() => {
    const firebasePartnerAnswer = _.get(
      partnerState,
      `${FIREBASE_STATE_KEYS.SHARED_PROFILE_ANSWERS}`,
      {}
    )
    const partnerAnswers =
      firebasePartnerAnswer && !_.isEmpty(firebasePartnerAnswer)
        ? firebasePartnerAnswer
        : _.get(sharedProfile, "partnerAnswers")
    //to set all the partner answers in disabled area
    if (partnerAnswers) {
      Object.keys(partnerAnswers).forEach((key, index) => {
        setPartnerAnswers(prevState => ({
          ...prevState,
          [key]: partnerAnswers[key],
        }))
      })
    }
  }, [partnerState])

  const goBackHandle = () => {
    history.push("/dashboard")
  }

  const handleChange = e => {
    let currentAnswer = {}
    currentAnswer[e.target.name] = e.target.value
    setanswers(Object.assign({ ...Question }, currentAnswer))
  }

  // on out of focus for each text area, save to db and firebase.
  const saveOneAnswer = async (index, name) => {
    const questionId = `Question${index}`
    await FirebaseService.patch(
      {
        [questionId]: Question[name] ? Question[name] : "",
      },
      `${firebaseDefaultPath}${props.user.uuid}/${[
        FIREBASE_STATE_KEYS.SHARED_PROFILE_ANSWERS,
      ]}`
    )
    saveAnswer(index, Question[name]).then(response => {
      let currIndex = {}
      currIndex[index] = true
      setSavedMessage(Object.assign({ ...savedMessage }, currIndex))
      setTimeout(() => {
        currIndex[index] = false
        setSavedMessage(Object.assign({ ...savedMessage }, currIndex))
      }, MESSAGE_TIMEOUT)
    })
  }

  const setJournalDate = async (date, dateString) => {
    const journalDate = getStringDateFormat(date, dateString)
    setanswers(prevState => ({
      ...prevState,
      journal_date: moment(journalDate),
    }))

    if (journalDate !== "Invalid date") {
      await FirebaseService.patch(
        {
          [FIREBASE_STATE_KEYS.JOURNAL_DATE]: journalDate,
        },
        `${firebaseDefaultPath}${props.user.uuid}/${[
          FIREBASE_STATE_KEYS.SHARED_PROFILE_ANSWERS,
        ]}`
      )
      saveJournalDate(journalDate)
    }
  }

  //display questions dynamically from constants
  const getQuestions = () => {
    return QUESTIONS.map((question, index) => (
      <div className="question-container" key={`que-${index}`}>
        <img className="cats-pic" src={images[index]} alt="couplecats"></img>
        <Text textType="sectionTextPrimary">
          {index + 1}. {index === 0 ? question.split(".")[0] : question}
        </Text>
        {index === 0 && (
          <div className="date-picker-container">
            <Date
              placeholder={DATE_PLACEHOLDER}
              format={DATE_MONTH_YEAR_FORMAT}
              onChange={setJournalDate}
              value={getMomentDateFormat(Question["journal_date"])}
              allowClear={false}
              className="enabled-date"
            />
            <Date
              dropdownClassName="partner-date"
              className="partner-date form-control-readonly"
              placeholder={DATE_PLACEHOLDER}
              format={DATE_MONTH_YEAR_FORMAT}
              inputReadOnly={true}
              value={getMomentDateFormat(PartnerQuestion["journal_date"])}
            />
          </div>
        )}
        {index === 0 && (
          <Text textType="sectionTextPrimary">{question.split(".")[1]}</Text>
        )}
        <div className="answers">
          <TextAreaWithIcon
            icon="none"
            className="your-answer"
            placeholder={ANSWER_PLACEHOLDER()}
            key={index + 1}
            name={`Question${index + 1}`}
            value={Question[`Question${index + 1}`]}
            onChange={handleChange}
            onBlur={e => {
              e.preventDefault()
              saveOneAnswer(index + 1, `Question${index + 1}`)
            }}
            saved={savedMessage[index + 1] && SAVED_MESSAGE}
            //un-comment only when passing an icon
            // parentref={setInputRef}
            // onIconClick={() => {
            //   answerInputRef.focus()
            // }}
          ></TextAreaWithIcon>
          <TextArea
            readOnly={true}
            className="partner-answer form-control-readonly"
            placeholder={ANSWER_PLACEHOLDER(partnerName)}
            key={`p${index + 1}`}
            value={PartnerQuestion[`Question${index + 1}`]}
          ></TextArea>
        </div>
      </div>
    ))
  }

  return (
    <div className="meet-keepurr-container">
      <div className="journal-wrapper">
        <div className="back-btn">
          <div className="page-header">
            <PageHeader
              onClick={goBackHandle}
              icon={<ArrowLeftOutlined />}
              btnText={BACK_BUTTON}
              headerText={JOURNAL_LABEL(chatSpaceName)}
            />
          </div>
        </div>
        {partnerDetails ? (
          <div>
            <div className="journal-questions-container">
              <Text textType="sectionHeading">
                {JOURNAL_WITH_LABEL(chatSpaceName)}
              </Text>
              {getQuestions()}
            </div>
          </div>
        ) : (
          <div className="no-partner">
            <Text textType="bodyHeading">
              {PARTNER_NOT_MATCHED}
              {INVITE_LINK}
            </Text>
          </div>
        )}
      </div>
      {/* <ReactTypeformEmbed
        className="type-form-popup"
        popup
        autoOpen={false}
        url={JOURNAL_POPUP_URL("q9mXuTJP")}
        hideHeaders
        hideFooter
        ref={tf => {
          setTypeFormEmbedBond(tf)
        }}
      />
      <ReactTypeformEmbed
        className="type-form-popup"
        popup
        autoOpen={false}
        url={JOURNAL_POPUP_URL("N3LRU2KL")}
        hideHeaders
        hideFooter
        ref={tf => {
          setTypeFormEmbedKeepur(tf)
        }}
      /> */}
    </div>
  )
}

const mapStateToProps = state => ({
  user: state.auth.user,
  myPartner: _.get(state, "auth.partner", {}),
  partnerDetails: _.get(state.invitePeople, "partnerDetails"),
  sharedProfile: _.get(state, "sharedProfile"),
})

export default connect(mapStateToProps, {
  saveAnswer,
  getAllAnswers,
  saveJournalDate,
})(JournalPage)
